const {h} = require("vue");
module.exports = function () {
    const videoPopup = document.querySelector(".video-popup");
    const videosBtn = document.querySelectorAll("[data-video-popup-src]");
    if ( !(videoPopup) ) return;
    const container = videoPopup.querySelector(".container");

    function setVideo(src = "", type = "video") {
        const element = videoPopup.querySelector(type);
        if ( !element ) return;
        if ( src === "" ) {
            if ( type === "video" ) element.pause();
            element.style.display = "none";
            element.removeAttribute("src");
        }
        else  {
            element.style.display = "block";
            element.setAttribute("src", type === "video" ? src : setUrl(src));
        }
    }

    const setUrl = (video) => {
        let url = video;
        if ( url.includes("embed/") ) {
            // do something
        }
        else if ( url.includes("watch?v=") ) {
            url = url.replace("watch?v=", "embed/");
        }
        else if ( url.includes("vimeo.com") && !url.includes("video") ) {
            url = url.replace("vimeo.com", "player.vimeo.com/video") + "?autoplay=1&autopause=0&controls=1";
        }
        else if ( url.includes("vimeo.com") && url.includes("video") ) {
            url = url + "?autoplay=1&autopause=0";
        }

        return url;
    }

    function openPopup (src = "", type = "video") {
        document.body.classList.add("overflow-hidden");
        videoPopup.classList.remove("invisible", "opacity-0");
        if ( src ) setVideo(src, type);

        setTimeout(() => {
            document.addEventListener("click", closeOutSide);
        })
    }

    function closePopup() {
        document.body.classList.remove("overflow-hidden");

        videoPopup.classList.add("invisible", "opacity-0");
        setVideo("", "video");
        setVideo("", "iframe");

        document.removeEventListener("click", closeOutSide);
    }

    function closeOutSide(e) {
        if ( !container.contains(e.target) ) closePopup();
    }

    for (const btn of videosBtn) {
        btn.addEventListener("click", () => {
            openPopup(btn.dataset.videoPopupSrc, btn.dataset.videoPopupType);
        })
    }

    const heroHolding = document.querySelector(".hero-holding");
    const heroHoldingVideo = document.querySelector(".hero-holding video");
    if ( !(heroHolding && heroHoldingVideo) ) return;

    setTimeout(() => {
        const handleLoad = () => {
            heroHolding.querySelector(".hero-holding-poster")?.remove();
            heroHoldingVideo.removeEventListener("play", handleLoad);
        }

        heroHoldingVideo.addEventListener("play", handleLoad);
        heroHoldingVideo.setAttribute("src", heroHoldingVideo.dataset.src);
    },  2000)
}